import { call, put, takeEvery } from "redux-saga/effects";
import { saveAs } from 'file-saver';
import { getErrorMessage, requestResultIsOk } from "../../utils/request-util";
import { objectKeysToUpperLowerCase } from "../../utils/objects-util";
import { createAction, createSaga, ErrorData } from '../../utils/sagaHelper';
import {
    REPORTS_HISTORY_DELETE, REPORTS_HISTORY_DOWNLOAD,
    REPORTS_HISTORY_GET,
    REPORTS_HISTORY_REFRESH,
    REPORTS_HISTORY_REMOVE,
    REPORTS_HISTORY_SET,
    REPORTS_HISTORY_UPDATE,
} from '../reducers/reportHistory/report-history-actions.js';
import { addHistoryReport, deleteHistoryReports, getReportById, getHistoryReports } from '../../api/reportsHistory-request.js';
import { ReportAction } from "../../utils/enums.js";

function* getHistoryReportsSaga(action) {
    yield* createSaga(function*() {
        const requestResult = yield call(getHistoryReports);
        if(requestResultIsOk(requestResult)) {
            yield put(createAction(REPORTS_HISTORY_SET, objectKeysToUpperLowerCase(requestResult.data.sort((a, b) => new Date(b.Updated || b.Created) - new Date(a.Updated || a.Created)))));
        } else {
            return new ErrorData(getErrorMessage(requestResult));
        }
    }, action.type);
}

function* deleteHistoryReportsSaga(action) {
    yield* createSaga(function*() {
        const requestResult = yield call(deleteHistoryReports, action.data);
        if(requestResultIsOk(requestResult)) {
            yield put(createAction(REPORTS_HISTORY_REMOVE, action.data));
            return true;
        } else {
            return new ErrorData(getErrorMessage(requestResult));
        }
    }, action.type);
}

function* saveFileSaga(action) {
    yield* createSaga(function*() {
        const requestResult = yield call(getReportById, action.data);
        if (requestResultIsOk(requestResult)) {
            const c = requestResult.headers["content-disposition"];
            let fileName = decodeURIComponent(c.split(";")[1].trim().split("=")[1].replace(new RegExp('"', "g"), ""));
            const octetStreamMime = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const contentType = requestResult.headers["content-type"] || octetStreamMime;
            const blob = new Blob([requestResult.data], { type: contentType });
            saveAs(blob, fileName);
            return
        } else {
            return new ErrorData(getErrorMessage(requestResult));
        }
    }, action.type);
}

function* refreshHistoryReportsSaga(action) {
    yield* createSaga(function*() {
        const requestResult = yield call(addHistoryReport, {
            ReportId: action.data,
            Action: ReportAction.Regenerate,
        });
        if(requestResult && requestResult.data) {
            yield put(createAction(REPORTS_HISTORY_UPDATE, objectKeysToUpperLowerCase(requestResult.data)));
        } else {
            return new ErrorData(getErrorMessage(requestResult));
        }
    }, action.type);
}

export default function* () {
    yield takeEvery(REPORTS_HISTORY_GET, getHistoryReportsSaga);
    yield takeEvery(REPORTS_HISTORY_DELETE, deleteHistoryReportsSaga);
    yield takeEvery(REPORTS_HISTORY_DOWNLOAD, saveFileSaga);
    yield takeEvery(REPORTS_HISTORY_REFRESH, refreshHistoryReportsSaga);
}